import { appointmentClinicBannerStorage } from '~/utils/storage/ubieAppStorage';

export const saveClinicBanner = (urlSearchParams: URLSearchParams) => {
  const visitFrom = urlSearchParams.get('visit_from');
  if (visitFrom != null) {
    appointmentClinicBannerStorage.set({
      visitFrom: decodeURIComponent(visitFrom),
      createdAt: Date.now(),
    });
  } else {
    // fromパラメータが無いということは、google導線からのランディングなので、データを削除しておく。
    appointmentClinicBannerStorage.delete();
  }
};
